import { useState } from "react";
import type { ApiStock } from "../services/api";

interface Props {
  open: boolean;
  stock: ApiStock | null;
  onClose: () => void;
  onConfirm: (quantity: number, price: number) => Promise<void> | void;
}

// 持仓对话框：输入持仓数量与成本价
export function HoldingDialog({ open, stock, onClose, onConfirm }: Props) {
  const [quantity, setQuantity] = useState("");
  const [price, setPrice] = useState("");
  const [busy, setBusy] = useState(false);

  if (!open || !stock) return null;

  const submit = async () => {
    const q = Number(quantity);
    const p = Number(price);
    if (!q || q <= 0 || !p || p <= 0) return;
    setBusy(true);
    try {
      await onConfirm(q, p);
      onClose();
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="dialog-overlay" onMouseDown={onClose}>
      <div className="dialog" onMouseDown={(e) => e.stopPropagation()}>
        <div className="dialog-title">
          {stock.name}（{stock.exchange}
          {stock.code}）
        </div>
        <div className="mb-3">
          <label className="label">持仓数量（股）</label>
          <input
            className="input"
            type="number"
            min={1}
            inputMode="numeric"
            placeholder="请输入持仓数量"
            value={quantity}
            onChange={(e) => setQuantity(e.target.value)}
          />
        </div>
        <div className="mb-4">
          <label className="label">成本价（元）</label>
          <input
            className="input"
            type="number"
            min={0.01}
            step="0.01"
            inputMode="decimal"
            placeholder="请输入成本价"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
          />
        </div>
        <div className="flex gap-2 justify-end">
          <button className="btn" onClick={onClose}>
            取消
          </button>
          <button
            className="btn btn-primary"
            disabled={busy || !quantity || !price}
            onClick={submit}
          >
            确认
          </button>
        </div>
      </div>
    </div>
  );
}
